import React, { useEffect, useState, useCallback, useContext } from "react";
import {
  Backdrop,
  CircularProgress,
  Divider,
  Tooltip,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Button,
  IconButton,
  Badge,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import Modal from "../../cm_shared/cm_global_modal";
import axios from "axios";
import DataTable from "react-data-table-component";
import { LoadingContext } from "../../../../context/spinnerContext";
// import ConditionalFilter from "../../../cm_shared/CMConditionalFilter";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import HistoryIcon from "@material-ui/icons/History";
import PublishIcon from "@material-ui/icons/Publish";
import ClearIcon from "@material-ui/icons/Clear";
import { FilterList, NoteAdd as NoteAddIcon } from "@material-ui/icons";
// import ScenarioGroupingFlow from "./../ScenarioGroupingFlow";
import CustomPagination from "./../../cm_shared/CMCustomPagination";
import { Link } from "react-router-dom";
import CMDeleteModal from "../../cm_shared/CMDeleteModal";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import { containsFctwPattern } from "../../../../helper"
import DescriptionIcon from '@material-ui/icons/Description';
// import options from "../../PGScenarioListing/options";
// import { pg_inner_table_data } from "./../../response";
const parseJSONString = (str) => {
  try {
    return JSON.parse(str.replace(/'/g, '"'));
  } catch (error) {
    return str;
  }
};

const customStyles = {
  table: {
    style: {
      // border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      minHeight: "72px",
      cursor: "pointer",
      fontSize: 16,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      // backgroundColor: "#b0ff45",
      justifyContent: "flex-start",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      justifyContent: "flex-start",
    },
  },
};
function TestRunsListing(props) {
  console.log("printing data drom fusion", props);
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { setIsLoading } = useContext(LoadingContext);
  const [scenarioCollectionNew, setScenarioCollectionNew] = useState([]);
  const [advancedSearchString, setAdvancedSearchString] = useState("");
  const [savedFilters, setSavedFilters] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [approveLoading, setApproveLoading] = useState(false);
  const [approveList, setApproveList] = useState([]);
  const [columns, setColumns] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const rowsPerPageSessionBased = [
    10, 20, 50, 100, 200, 300, 500, 700, 1000, 1200, 1500, 1800, 2000, 2500,
    3000,
  ];
  const [eventsPerPage, setEventsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [deleteScenarioUuid, setDeleteScenarioUuid] = useState(null);
  const [disableEscapeKeyDown, setDisableEscapeKeyDown] = useState(false);
  const [disableBackdropClick, setDisableBackdropClick] = useState(false);
  const [sizeForModal, setSizeForModal] = useState("lg");
  const [allSelected, setAllSelected] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [modelOptions, setModelOptions] = useState([]);
  const [currentFilters, setCurrentFilters] = useState({});
  const [sortOrder, setSortOrder] = useState("")
  const [sortField, setSortField] = useState("")
  
  const handleSort = (column, direction) => {
    setSortField(column.selector);
    setSortOrder(direction);
  };

  const handleChange = async (event) => {
    console.log('printing event', event);
    const newRow = event.selectedRows;
    if (scenarioCollectionNew.length === newRow.length || event.allSelected) {
      props.onSelectAllRow(newRow, selectedRows);
    } else if (newRow.length === 0 && !event.allSelected) {
      props.onDeselectAllRow(selectedRows);
    } else if (newRow.length !== selectedRows.length) {
      if (newRow.length < selectedRows.length) {
        const deSelectedArr = selectedRows.filter(obj1 => 
          !newRow.some(obj2 => obj2.scheduler_uuid === obj1.scheduler_uuid)
        );
        if (deSelectedArr.length > 0) props.onSelectRow(deSelectedArr[0], true);
        else props.onSelectRow(selectedRows[0], true);
      } else newRow.length > 0 && props.onSelectRow(newRow[0]);
    }
    setSelectedRows(event.selectedRows);
  }

  const handleViewReport = (row) => {
    // const isFctw = containsFctwPattern(`${row.tag_name}`);
    const reportUrl = `/reporting?page=closed_loop&execution_id=${row.execution_uuid}&test_run_id=${row.test_run_id}&reporting_level=test_run_id&scenario_group_name=${row.scenario_group_name}`;
    window.open(reportUrl, "_blank");
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleGenerateReport = async (row) => {
    console.log("ROW", row);
    const isFctw = containsFctwPattern(`${row.tag_name}`) ;
    const awsUrl = isFctw ? process.env.REACT_APP_REPORTING_CLOSE_LOOP_FCTW_LAMBDA_URL :
    process.env.REACT_APP_REPORTING_LAMBDA_FUNCTION_URL;
    try {
      setIsLoading(true);
      const response = await axios.post(
        awsUrl,
        { ...row, reporting_level: "test_run_id" },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("RESPONSE FROM LAMBDA", response);
      setDialogMessage("Report generated successfully.");
    } catch (error) {
      console.error("Error generating report:", error);
      setDialogMessage("Failed to generate report.");
    } finally {
      setIsLoading(false);
      setDialogOpen(true);
    }
  };
  const handleDownload = async (filePath) => {
    const fileToDownload = await axios.post(
      "/generate-presigned-url",
      {
        s3_location: filePath,
      }
      // { responseType: "blob" }
    );
    console.log(fileToDownload);
    window.open(fileToDownload.data.presigned_url);
  };

  const initialColumns = [
    // {
    //   name: "Test Run ID",
    //   selector: "test_run_id",
    //   sortable: true,
    //   reorder: true,
    //   grow: 3,

    // },
    {
      name: "Scenario Group",
      selector: "scenario_group_name",
      sortable: true,
      grow: 3,
      cell: (row) => {
        return (
          <span>{row.scenario_group_name}</span>
        )
      }
    },

    {
      name: "Total Scenarios",
      selector: "total_scenario_count",
      sortable: true,
    },
    {
      name: "Completed",
      selector: "scenario_completed_count",
      sortable: true,
    },
    {
      name: "Updated At",
      selector: "updated_at",
      sortable: true,
      grow: 2,
    },
    {
      name: "Updated By",
      selector: "updated_by",
      sortable: false,
      grow: 2,
    },
    {
      name: "Actions",
      selector: "actions",
      sortable: false,
      cell: (row) => (
        <div style={{ display: "flex" }}>
          <Tooltip placement="top" title={<h6>Generate Report</h6>}>
            <IconButton
              aria-label="delete"
              onClick={() => handleGenerateReport(row)}
              style={{ padding: "4px", marginLeft: '-0.5rem' }}
            >
              <PlayCircleFilledWhiteIcon />
            </IconButton>
          </Tooltip>
          <Tooltip placement="top" title={<h6>View Report</h6>}>
            <IconButton
              onClick={() => handleViewReport(row)}
              style={{ padding: "4px" }}
            >
              <DescriptionIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setEventsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchLogicalFusionData = async () => {
    console.log("called fusion api");
    setIsLoading(true);
    const response = await axios.post(
      `/cm_close_loop/fetchTestRunIdsForExecution`,
      {
        execution_uuid: props.data.execution_uuid,
        page_number_record: page + 1,
        page_size_record: eventsPerPage,
        sort_field_record: sortField,
        sort_order_record: sortOrder
      }
    ).catch((err) => {
      console.error(err);
    }).finally(() => {
      setIsLoading(false);
    });

    setPreselectedRow(response.data);
    setScenarioCollectionNew(response.data.data);
    setTotal(response.data["total_records"]);
  };

  useEffect(() => {
    setColumns(initialColumns);
    fetchLogicalFusionData();
  }, [eventsPerPage, page, sortField, sortOrder]);

  useEffect(() => {
    setColumns(initialColumns);
  }, [props.cartItems, approveLoading]);

  useEffect(() => {
    props.allSelect && props.updateCart(scenarioCollectionNew, "add", true);
  }, [props.allSelect]);

  const setPreselectedRow = (res) => {
    if (props.selectedRows.length > 0) {
      const newSelectedRow = res.data.filter(item => props.selectedRows.find(obj => obj.scheduler_uuid === item.scheduler_uuid))
      setSelectedRows(newSelectedRow);
    }
  }

  const handleAddToCart = useCallback((scenario) => {
    props.updateCart(scenario, "add");
  }, []);

  const handleRemoveFromCart = (scenarioId) => {
    props.updateCart(scenarioId, "remove");
  };

  const handleDelete = async (scenarioUuid) => {
    try {
      await axios.post(`/cm/close_loop/delete-carmaker-scenario`, scenarioUuid);
      fetchLogicalFusionData();
    } catch (error) {
      console.error("Failed to delete the scenario:", error);
    } finally {
      setConfirmDeleteOpen(false);
    }
  };

  const handleApprove = async (scenarioUuid, data_type) => {
    try {
      setApproveList((prevList) => {
        return [...prevList, scenarioUuid];
      });
      setApproveLoading(true);
      await axios.post(`/cm/open_loop/move-file`, {
        scenario_uuid: scenarioUuid,
        delete_flag: "False",
        data_type: data_type,
      });
      fetchLogicalFusionData();
    } catch (error) {
      console.error("Failed to approve the data:", error);
    } finally {
      setApproveList((prevEle) => {
        const newArr = prevEle.filter((ele) => ele !== scenarioUuid);
        return newArr;
      });
      setApproveLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "1rem",
        background: "white",
        margin: "30px",
        borderRadius: "10px",
      }}
    >
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={"lg"}
        disableEscapeKeyDown={disableEscapeKeyDown}
        disableBackdropClick={disableBackdropClick}
      />

      <div
        style={{
          border: "solid 1px rgba(0,0,0,.5)",
          borderRadius: "10px",
        }}
      >
        <CustomPagination
          total={total}
          rowsPerPageOptions={rowsPerPageSessionBased}
          eventsPerPage={eventsPerPage}
          page={page}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          onPageChange={handlePageChange}
        />
        {columns.length > 0 ? (
          <DataTable
            selectableRows
            selectableRowDisabled={(row) => row.file_path === null || row.file_path === ''}
            onSelectedRowsChange={handleChange}
            onSort={handleSort}
            sortServer
            selectableRowSelected={(row) => selectedRows.some(obj => Object.keys(obj).some(key => obj[key] === row.scheduler_uuid))}
            clearSelectedRows={props.clearRows}
            columns={columns}
            data={scenarioCollectionNew}
            customStyles={customStyles}
          ></DataTable>
        ) : null}
      </div>
      <CMDeleteModal
        open={confirmDeleteOpen}
        message="Are you sure you want to delete this scenario?"
        onCancel={() => setConfirmDeleteOpen(false)}
        onConfirm={() => handleDelete(deleteScenarioUuid)}
      />
      <Dialog
          open={dialogOpen}
          onClose={handleDialogClose}
          aria-labelledby="dialog-title"
          aria-describedby="dialog-description"
        >
          <DialogTitle id="dialog-title">API Response</DialogTitle>
          <DialogContent>
            <DialogContentText id="dialog-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
}

export default TestRunsListing;
